import { AdaptiveLogo } from "@/components/logos/AdaptiveLogo"
import { ADAPTIVE_URL } from "@/constants"

export const AdaptiveLogoLink = (
  <div className="pr-2xl leading-[0] hover:cursor-pointer">
    <AdaptiveLogo
      size={1.75}
      role="button"
      onClick={() => {
        window.gtag("event", "outbound_click", {
          destination: ADAPTIVE_URL,
        })
        window.open(ADAPTIVE_URL)
      }}
    />
  </div>
)
